<template>
    <div class="ur-step-item" v-show="true">
        <!--
            $ver: v0.1.0
            content영역을 채우는 default slot입니다.
            #The default slot that fills the content area.
        -->
        <slot/>
    </div>
</template>

<script>
// ur-step-item은 ur-step-box에 종속된 자식 컴포넌트 입니다,
// #ur-step-item is a child component of ur-step-box
export default {
    name : "urStepItem"
}
</script>
